import React from "react";
import { MdOutlineSmsFailed } from "react-icons/md";
function NotFound() {
  return (
    <div className="w-full flex h-screen bg-red-100">
      <div className="m-auto w-80 p-4 bg-red-300 rounded">
        <div className="flex">
          <MdOutlineSmsFailed className="my-auto text-white mr-2" />{" "}
          <h2 className="text-white font-semibold py-2">Not Found </h2>
        </div>
        <p className="text-xs text-white">
          The page you're searching is not available try to navigate to other
          pages.
        </p>
      </div>
    </div>
  );
}

export default NotFound;
